import {Component, OnInit, ViewChild} from '@angular/core';
import {CurrencyPipe, DatePipe, NgForOf} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {CancelledReceiptPosition} from "../../shared/models/cancelledReceiptPosition";
import {OrderService} from "../../core/http/order.service";
import {AuthService} from "../../core/auth/auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatSort, MatSortModule} from "@angular/material/sort";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";

@Component({
  selector: 'app-cancel-order-overview',
  standalone: true,
  imports: [
    CurrencyPipe,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    DatePipe,
    MatInputModule,
    MatSelectModule,
    NgForOf,
    MatSortModule
  ],
  templateUrl: './cancel-order-overview.component.html',
  styleUrl: './cancel-order-overview.component.scss'
})
export class CancelOrderOverviewComponent implements OnInit {

  cancelledPositions: CancelledReceiptPosition[] = [];
  displayedColumns: string[] = ['waiter', 'itemName', 'singlePrice', 'quantity', 'totalAmount', 'created', 'accept', 'decline'];

  currentSelectedWaiter = '';

  dataSource!: MatTableDataSource<CancelledReceiptPosition>;
  waiterFilterValues: string[] = [];
  @ViewChild(MatSort, {static: true}) sort!: MatSort;

  constructor(private orderService: OrderService, private authService: AuthService, private _snackBar: MatSnackBar) {
  }

  populateWaiterFilterValues() {
    const waitersSet = new Set<string>();
    this.cancelledPositions.forEach(position => {
      if (position.createdBy != null) {
        waitersSet.add(position.createdBy);
      }
    });
    this.waiterFilterValues = Array.from(waitersSet);
  }

  applyFilter(filterValue: string) {
    this.currentSelectedWaiter = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.orderService.getAllCancelledMarkedReceiptPositions().subscribe({
      next: (response) => {
        this.cancelledPositions = response;
        this.dataSource = new MatTableDataSource<CancelledReceiptPosition>(this.cancelledPositions);
        this.dataSource.sort = this.sort;
        this.populateWaiterFilterValues();
        if (this.currentSelectedWaiter !== '') {
          this.applyFilter(this.currentSelectedWaiter);
        }
      },
      error: (error) => {
        console.error(error);
      }
    });
  }

  acceptCancellation(guid: string): void {
    this.orderService.cancelOrderPosition(guid, this.authService.getUserName()).subscribe({
      next: (response) => {
        console.log('send cancel order position');
        this._snackBar.open('Stornierung bestätigt', 'Schließen', {duration: 3000});
        this.loadData();
      },
      error: (error) => {
        this._snackBar.open('Beim Stornieren ist ein Fehler aufgetreten', 'Schließen', {duration: 3000});
        console.error(error);
      }
    });
  }

  declineCancellation(guid: string): void {
    this.orderService.declineCancelOrderPosition(guid, this.authService.getUserName()).subscribe({
      next: (response) => {
        console.log('decline cancel order position');
        this._snackBar.open('Stornierung erfolgreich abgelehnt', 'Schließen', {duration: 3000});
        this.loadData();
      },
      error: (error) => {
        this._snackBar.open('Beim Ablehnen der Stornierung ist ein Fehler aufgetreten', 'Schließen', {duration: 3000});
        console.error(error);
      }
    });
  }


}
